import { render, staticRenderFns } from "./supercStoreManage.vue?vue&type=template&id=0130882e&"
import script from "./supercStoreManage.vue?vue&type=script&lang=js&"
export * from "./supercStoreManage.vue?vue&type=script&lang=js&"
import style0 from "./supercStoreManage.vue?vue&type=style&index=0&id=0130882e&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports